module.exports = __webpack_public_path__ + "img/residential.78ab9ee5.svg";